import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Chat: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#chat-clip)">
      <path
        d="M7.41032 21.3871C8.79547 22.0654 10.3528 22.4463 11.9992 22.4463C17.7686 22.4463 22.4456 17.7694 22.4456 11.9999C22.4456 6.23049 17.7686 1.55347 11.9992 1.55347C6.22976 1.55347 1.55273 6.23049 1.55273 11.9999C1.55273 14.1416 2.19723 16.1327 3.30285 17.7899M7.41881 21.3856L7.41032 21.3871L1.55273 22.4463L3.30285 17.7899M3.30285 17.7899L3.30452 17.7856"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0014 12.4017C11.7795 12.4017 11.5996 12.2218 11.5996 11.9999C11.5996 11.778 11.7795 11.5981 12.0014 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.002 12.4017C12.2239 12.4017 12.4037 12.2218 12.4037 11.9999C12.4037 11.778 12.2239 11.5981 12.002 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58343 12.4017C7.36153 12.4017 7.18164 12.2218 7.18164 11.9999C7.18164 11.778 7.36153 11.5981 7.58343 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58398 12.4017C7.80588 12.4017 7.98577 12.2218 7.98577 11.9999C7.98577 11.778 7.80588 11.5981 7.58398 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4213 12.4017C16.1994 12.4017 16.0195 12.2218 16.0195 11.9999C16.0195 11.778 16.1994 11.5981 16.4213 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4219 12.4017C16.6438 12.4017 16.8236 12.2218 16.8236 11.9999C16.8236 11.778 16.6438 11.5981 16.4219 11.5981"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="chat-clip">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
